import { faNewspaper } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Typography } from "@mui/material"
import { StyledAvatar, StyledCard, StyledCardContent } from "shared/styled/General"
import { useTranslation } from "react-i18next";

const NoNewsCard = () => {
  const { t } = useTranslation("translation")

  return (
    <Grid xs={12} item>
      <StyledCard>
        <StyledCardContent>
          <StyledAvatar aria-label="recipe">
            <FontAwesomeIcon size="lg" icon={faNewspaper} />
          </StyledAvatar>
          <Typography variant="h3">{t("news.no_new_news", "There are currently no news items")}</Typography>
        </StyledCardContent>
      </StyledCard>
    </Grid>
  )
}

export default NoNewsCard
